module.exports = __webpack_public_path__ + "static/img/guide_pic2.9b09cb9.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/guide_pic2.png
// module id = wbLF
// module chunks = 1